// Full-screen camera preview component

import { forwardRef } from 'react'

interface CameraPreviewProps {
  className?: string
}

const CameraPreview = forwardRef<HTMLVideoElement, CameraPreviewProps>(
  ({ className = '' }, ref) => {
    return (
      <video
        ref={ref}
        autoPlay
        playsInline
        muted
        className={`w-full h-full object-cover bg-gray-900 ${className}`}
      />
    )
  }
)

CameraPreview.displayName = 'CameraPreview'

export default CameraPreview
